import { DebounceFormInput } from '@/features/transaction_items/Detail/components/Drawer/Form/DebounceFormInput';
import { TransactionDetailOptionFormType } from '@/features/transaction_items/Detail/type';
import { useTranslation } from '@/i18n';
import { Label } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, useMemo } from 'react';
import { Control } from 'react-hook-form';
import styles from './TransactionDetailOptionForm.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  control: Control<TransactionDetailOptionFormType>;
};

export const OptionLabel: FC<Props> = memo(({ control }) => {
  const { t } = useTranslation();
  const rules = useMemo(() => {
    return {
      required: t('required'),
      maxLength: {
        value: 100,
        message: t('transaction_items.detail.options.validation.label'),
      },
    };
  }, [t]);
  return (
    <div className={cx(styles['row'])}>
      <Label htmlFor='label' required>
        <div className={cx(styles['bold'])}>
          {t('transaction_items.detail.options.label')}
        </div>
      </Label>
      <DebounceFormInput
        control={control}
        name='label'
        inputId='label'
        testId='transaction-detail-option-label'
        rules={rules}
        debounceMs={0}
        descriptionMessage={t(
          'transaction_items.detail.options.validation.label'
        )}
      />
    </div>
  );
});
OptionLabel.displayName = 'OptionLabel';
